module.exports = __webpack_public_path__ + "static/image7_mobile-b30d9a43704ab32983a98862bff8897c.png";